import React from "react";
import "./LegalPages.css";

const PrivacyPolicy = () => {
  return (
    <section className="legal-page">
      <h1>Privacy Policy</h1>
      <p>
        At <b>Mailsnappy</b>, your privacy is important to us. This policy explains how we collect,
        use, and protect your personal information.
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We collect personal data such as name, email address, and billing details when you register
        or use our services.
      </p>

      <h2>2. How We Use Your Data</h2>
      <p>
        We use your information to provide services, send updates, improve our platform, and
        communicate with you regarding your account.
      </p>

      <h2>3. Data Protection</h2>
      <p>
        We use advanced security measures to protect your data against unauthorized access,
        alteration, or disclosure.
      </p>

      <h2>4. Cookies</h2>
      <p>
        Our website uses cookies to enhance user experience and track usage patterns. You can manage
        cookie preferences through your browser settings.
      </p>

      <h2>5. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal information by contacting us
        at <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a>.
      </p>

      <h2>6. Updates</h2>
      <p>
        This Privacy Policy may be updated periodically. Please check this page for any changes.
      </p>
    </section>
  );
};

export default PrivacyPolicy;
